module.exports = __webpack_public_path__ + "static/media/logo-food-order.3675fea8.png";